/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'confluence.error.panel.refresh.app': '重新整理應用程式',
  'confluence.error.panel.reload.page': '重新載入頁面',
  'confluence.icon.label': '圖示',
  'confluence.modal.dialog.close.modal.button': '取消',
  'confluence.select.required.field.message': '這是必填欄位。',
  'confluence.text.area.required.field.message': '這是必填欄位。',
  'confluence.textfield.validator.email': '請輸入有效的電子郵件。',
  'confluence.textfield.validator.number': '請輸入有效的數字',
  'confluence.textfield.validator.required.field.message': '這是必填欄位。',
  'confluence.textfield.validator.telephone': '請輸入有效的電話號碼。',
  'confluence.threeLOPrompt.modal.access.required.title': '需要存取權',
  'confluence.threeLOPrompt.modal.error.title': '錯誤',
  'confluence.threeLOPrompt.modal.no.authURL.error-message': '找不到同意 URL。請重新整理頁面，然後再試一次。',
  'confluence.threeLOPrompt.no.authURL.error-message': '找不到同意 URL。請重新整理頁面，然後再試一次。',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': '允許存取',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': '設定存取權',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': '驗證失敗。',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    '若要讓 {appString} 顯示，您必須允許應用程式代表您存取 Atlassian 產品。',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': '{appString} 需要對您的帳戶取得其他存取權。',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': '外部驗證警告',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': '此應用程式',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': '此應用程式',
  'confluence.user.group.unknown.user.message': '未知使用者',
  'confluence.user.picker.empty.field.error.message': '這是必填欄位。',
  'confluence.user.unknown.user.message': '未知使用者',
  'forge-ui.form.submit-button.text': '提交',
  'forge.modal.deprecation.message':
    '您的應用程式 {appName} 將已淘汰的強制回應編輯功能用於自訂欄位，這很快就無法再使用。請讓系統管理員更新應用程式，以改為使用內嵌編輯功能。如果問題仍然存在，請連絡應用程式開發人員。',
  'forge.modal.deprecation.title': '更新您的應用程式',
};
